export default __webpack_public_path__ + "GreycliffCF-Regular.woff2";